module.exports = __webpack_public_path__ + "static/media/Deli_Wrong.ebf27e58.svg";